/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { PostTourRequest } from '../../models/post-tour-request';
import { TourResponse } from '../../models/tour-response';

export interface PostTour$Params {
  organizationSiteKey: KeyType;
      body: PostTourRequest
}

export function postTour(http: HttpClient, rootUrl: string, params: PostTour$Params, context?: HttpContext): Observable<StrictHttpResponse<TourResponse>> {
  const rb = new RequestBuilder(rootUrl, postTour.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TourResponse>;
    })
  );
}

postTour.PATH = '/organization-sites/{organizationSiteKey}/carrier/tours';
